import { HeaderTitle } from '../HeaderTitle';

import './index.scss';

export const TransparentHeader = () => (
    <div className="transparent-header header">
        <HeaderTitle />
    </div>
);